import Phaser from 'phaser';
import { AchievementId } from '../types/Achievement';
import { ACHIEVEMENT_META } from '../constants/achievementConfig';
import { GAME_WIDTH } from '../scenes/gameConfig';

const TOAST_DEPTH = 190;
const TOAST_DURATION_MS = 2500;
const TOAST_FADE_MS = 400;
const TOAST_INTERVAL_MS = 3600;

const TOAST_W = 360;
const TOAST_H = 72;
const TOAST_X = GAME_WIDTH / 2;
const TOAST_Y_VISIBLE = 56;

function showSingleToast(scene: Phaser.Scene, id: AchievementId): void {
  const meta = ACHIEVEMENT_META[id];
  if (!meta) return;

  const container = scene.add.container(TOAST_X, TOAST_Y_VISIBLE - TOAST_H).setDepth(TOAST_DEPTH).setAlpha(0);

  const bg = scene.add.rectangle(0, 0, TOAST_W, TOAST_H, 0x1a1a2e).setStrokeStyle(2, 0xf0c040);
  const label = scene.add
    .text(0, -12, '実績解除！', {
      fontSize: '14px',
      color: '#f0c040',
      fontFamily: "'Noto Sans JP', Arial, sans-serif",
      fontStyle: 'bold',
    })
    .setOrigin(0.5);
  const nameText = scene.add
    .text(0, 12, meta.name, {
      fontSize: '20px',
      color: '#ffffff',
      fontFamily: "'Noto Sans JP', Arial, sans-serif",
      fontStyle: 'bold',
    })
    .setOrigin(0.5);

  container.add([bg, label, nameText]);

  scene.tweens.add({
    targets: container,
    alpha: 1,
    y: TOAST_Y_VISIBLE,
    duration: TOAST_FADE_MS,
    ease: 'Cubic.easeOut',
    onComplete: () => {
      scene.time.delayedCall(TOAST_DURATION_MS, () => {
        scene.tweens.add({
          targets: container,
          alpha: 0,
          duration: TOAST_FADE_MS,
          ease: 'Cubic.easeIn',
          onComplete: () => container.destroy(),
        });
      });
    },
  });
}

export function showAchievementToast(scene: Phaser.Scene, ids: AchievementId[]): void {
  if (ids.length === 0) return;
  ids.forEach((id, i) => {
    scene.time.delayedCall(i * TOAST_INTERVAL_MS, () => {
      showSingleToast(scene, id);
    });
  });
}
